// Admin Menu Route
const Admin = () => import(/* webpackChunkName: "Admin" */ '../views/Admin')
const Pulse = () => import(/* webpackChunkName: "Pulse" */ '../views/Admin/Pulse')
// const Measurement = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement')	
const AllMeasurement = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AllMeasurement')	
const DetailBus = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AllMeasurement/Bus/Detail')	
const BusMeasurement = () => import(/* webpackChunkName: "Bus" */ '../views/Admin/Measurement/AllMeasurement/Bus')	
const AllCampaign = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AllMeasurement/AllCampaign')	
const AddNew = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AddNew')	
const Edit = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/EditMeasurement')	
const Traffic = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AllMeasurement/AllCampaign/Traffic')	
const Impact = () => import(/* webpackChunkName: "Measurement" */ '../views/Admin/Measurement/AllMeasurement/AllCampaign/Impact')	
const AllLocation = () => import(/* webpackChunkName: "AllLocation" */ '../views/Admin/Locations/AllLocation')	
const AddMoreLocation = () => import(/* webpackChunkName: "AddMoreLocation" */ '../views/Admin/Locations/AddMore')	
const EditLocation = () => import(/* webpackChunkName: "EditLocation" */ '../views/Admin/Locations/EditLocation')	
const Vouchers = () => import(/* webpackChunkName: "Vouchers" */ '../views/Admin/Vouchers')	
const VouchersList = () => import(/* webpackChunkName: "VouchersList" */ '../views/Admin/Vouchers/VouchersList')	
const VouchersRedemptionList = () => import(/* webpackChunkName: "VouchersRedemptionList" */ '../views/Admin/Vouchers/VouchersRedemptionList')	
const AddMoreVoucher = () => import(/* webpackChunkName: "AddMoreVoucher" */ '../views/Admin/Vouchers/AddMore')	
const AddNewUser = () => import(/* webpackChunkName: "AddNewUser" */ '../views/Admin/User/AddNew')	
const UserReport = () => import(/* webpackChunkName: "UserReport" */ '../views/Admin/User/UserReport')	
const FinalBalance = () => import(/* webpackChunkName: "FinalBalance" */ '../views/Admin/Transaction/FinalBalance')	
const AllBalance = () => import(/* webpackChunkName: "AllBalance" */ '../views/Admin/Transaction/AllBalance')	
const Campaigns = () => import(/* webpackChunkName: "Campaigns" */ '../views/Admin/Transaction/Campaigns')	
const DeviceList = () => import(/* webpackChunkName: "DeviceList" */ '../views/Admin/Devices/DevicesList')	
const AddNewDevice = () => import(/* webpackChunkName: "AddNewDevice" */ '../views/Admin/Devices/AddNew')	
const PertaminaReport = () => import(/* webpackChunkName: "PertaminaReport" */ '../views/Admin/Pertamina/PertaminaReport')	
const EditDevice = () => import(/* webpackChunkName: "EditDevice" */ '../views/Admin/Devices/EditDevice')	
const UnwatchedDevices = () => import(/* webpackChunkName: "UnwatchedPulses" */ '../views/Admin/UnwatchedDevices')	
const WatchedDevices = () => import(/* webpackChunkName: "WatchedPulses" */ '../views/Admin/WatchedDevices')	
const PulseTask = () => import(/* webpackChunkName: "PulseTask" */ '../views/Admin/PulseTask')	
const Listings = () => import(/* webpackChunkName: "Listings" */ '../views/Admin/Listings')	
const DigitalScreenListings = () => import(/* webpackChunkName: "DigitalScreenListings" */ '../views/Admin/Listings/DigitalScreen')	
const BusListings = () => import(/* webpackChunkName: "BusListings" */ '../views/Admin/Listings/Bus')	
const AddNewListing = () => import(/* webpackChunkName: "AddNewListing" */ '../views/Admin/Listings/AddNew')	
const BusChannel = () => import(/* webpackChunkName: "BusChannel" */ '../views/Admin/Channel/Bus')	
const AddEditRoute = () => import(/* webpackChunkName: "EditRoute" */ '../views/Admin/Channel/Bus/Route/AddEdit')
const AddEditPlacement = () => import(/* webpackChunkName: "EditPlacement" */ '../views/Admin/Channel/Bus/Placement/AddEdit')
const BusRoute = () => import(/* webpackChunkName: "BusRoute" */ '../views/Admin/Channel/Bus/Route')	
const BusPlacement = () => import(/* webpackChunkName: "BusPlacement" */ '../views/Admin/Channel/Bus/Placement')	
const AddNewBusPlacement = () => import(/* webpackChunkName: "AddNewBusPlacement" */ '../views/Admin/Channel/Bus/Placement/AddNew')	
const EditBusPlacement = () => import(/* webpackChunkName: "EditBusPlacement" */ '../views/Admin/Channel/Bus/Placement/Edit')	

//Channel Airline
const AirlineChannel = () => import(/* webpackChunkName: "AirlinesChannel" */ '../views/Admin/Channel/Airlines')	
const AirlineMedia = () => import(/* webpackChunkName: "AirlinesMedia" */ '../views/Admin/Channel/Airlines/Media')	
const AirlineMediaForm = () => import(/* webpackChunkName: "AirlinesMediaForm" */ '../views/Admin/Channel/Airlines/Media/Form')	
const AirlinePlacement = () => import(/* webpackChunkName: "AirlinesPlacement" */ '../views/Admin/Channel/Airlines/Placement')
const AirlinePlacementForm = () => import(/* webpackChunkName: "AirlinesPlacementForm" */ '../views/Admin/Channel/Airlines/Placement/Form')	
const AirlineProfile = ()=> import(/* webpackChunkName: "AirlinesProfile" */ '../views/Admin/Channel/Airlines/Profile')	

const Remote = () => import(/* webpackChunkName: "Remote" */ '../views/Admin/Remote')	
const Terminal = () => import(/* webpackChunkName: "Terminal" */ '../views/Admin/Remote/Terminal')	
const PlaybackSummary = () => import('../views/Admin/PlaybackSummary')	
const UnassignedTicket = () => import('../views/Admin/UnassignedTicket')	
const TaskPerformance = () => import('../views/Admin/TaskPerformance')	

// Task Manager	
const TaskAssignment = () => import(/* webpackChunkName: "TaskAssignment" */ '../views/Admin/TaskManager/Assignment')	
const NewTask = () => import(/* webpackChunkName: "NewTask" */ '../views/Admin/TaskManager/NewTask')	
const TaskAssesment = () => import(/* webpackChunkName: "TaskAssesment" */ '../views/Admin/TaskManager/Assesment')	
const CampaignMonitoring = () => import(/* webpackChunkName: "MonitoringCampaign" */ '../views/Admin/TaskManager/MonitoringCampaign')	
const NewCampaignMonitoring = () => import(/* webpackChunkName: "MonitoringCampaign" */ '../views/Admin/TaskManager/NewCampaignMonitoring')	
const EditCampaignMonitoring = () => import(/* webpackChunkName: "EditCampaignMonitoring" */ '../views/Admin/TaskManager/EditCampaignMonitoring')

// Sharing Scheme
/// import Sharing from './views/Sharing'
const Sharing = () => import(/* webpackChunkName: "Sharing" */ '../views/Sharing')
/// import Cost from './views/Sharing/Cost'
const Cost = () => import(/* webpackChunkName: "Cost" */ '../views/Sharing/Cost')
/// import DetailCost from './views/Sharing/Cost/Detail'
const DetailCost = () => import(/* webpackChunkName: "Cost" */ '../views/Sharing/Cost/Detail')
/// import Discount from './views/Sharing/Discount'
const Discount = () => import(/* webpackChunkName: "Discount" */ '../views/Sharing/Discount')
/// import Revenue from './views/Sharing/Revenue'
const Revenue = () => import(/* webpackChunkName: "Revenue" */ '../views/Sharing/Revenue')

// Billboard
const BillboardChannel = () => import(/* webpackChunkName: "BillboardChannel" */ '../views/Admin/Channel/Billboard')
const BillboardLocation = () => import(/* webpackChunkName: "BillboardLocation" */ '../views/Admin/Channel/Billboard/Location')
const BillboardPlacement = () => import(/* webpackChunkName: "BillboardPlacement" */ '../views/Admin/Channel/Billboard/Placement')
const AddEditPlacementBillboard = () => import(/* webpackChunkName: "AddEditPlacement" */ '../views/Admin/Channel/Billboard/Placement/AddEdit')
const AddEditLocationBillboard = () => import(/* webpackChunkName: "AddEditLocation" */ '../views/Admin/Channel/Billboard/Location/AddEdit')

const adminRouter = [
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { isStaff: true },
      children: [
        {
          path: '/admin/pulse',
          name: 'pulse',
          component: Pulse,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/alllocation',
          name: 'alllocation',
          component: AllLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/addmore',
          name: 'addmorelocation',
          component: AddMoreLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/edit/:id',
          name: 'editlocation',
          component: EditLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/vouchers',
          name: 'vouchers',
          component: Vouchers,
          redirect: '/admin/vouchers/voucherslist',
          meta: { isSuperuser: true },
          children: [
            {
              path: '/admin/vouchers/voucherslist',
              name: 'voucherslist',
              component: VouchersList,
              meta: { isSuperuser: true },
            },
            {
              path: '/admin/vouchers/vouchersredemptionlist',
              name: 'vouchersredemptionlist',
              component: VouchersRedemptionList,
              meta: { isSuperuser: true },
            }
          ]
        },
        {
          path: '/admin/vouchers/addmore',
          name: 'addmorevoucher',
          component: AddMoreVoucher,
          meta: { isSuperuser: true }
        },
        {
          path: '/admin/user/addnew',
          name: 'addnewuser',
          component: AddNewUser,
          meta: { isUserManager: true }
        },
        {
          path: '/admin/user/all',
          name: 'userreport',
          component: UserReport,
          meta: { isUserManager: true }
        },
        {
          path: '/admin/transaction/final',
          name: 'finalbalance',
          component: FinalBalance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/transaction/all',
          name: 'allbalance',
          component: AllBalance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/transaction/campaigns',
          name: 'campaigns',
          component: Campaigns,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/deviceslist',
          name: 'devicelist',
          component: DeviceList,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/addnew/',
          name: 'addnewdevice',
          component: AddNewDevice,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allmeasurement',
          name: 'allmeasurement',
          component: AllMeasurement,
          redirect: { name: 'allcampaign' },
          meta: { isStaff: true },
          children: [
            {
              path: 'allcampaign',
              name: 'allcampaign',
              component: AllCampaign,
              meta: { isStaff: true }
            },
            {
              path: 'busmeasurement',
              name: 'busmeasurement',
              component: BusMeasurement,
              meta: { isStaff: true },
            },
          ]
        },
        {
          path: '/admin/measurement/detailbus/:id',
          name: 'detailbus',
          component: DetailBus,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/addnew',
          name: 'addnew',
          component: AddNew,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/edit',
          name: 'edit',
          component: Edit,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allcampaign/traffic',
          name: 'traffic',
          component: Traffic,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allcampaign/impact',
          name: 'impact',
          component: Impact,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/edit/:pub_id',
          name: 'editdevice',
          component: EditDevice,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing',
          name: 'sharing',
          component: Sharing,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/cost',
          name: 'cost',
          component: Cost,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/cost/:costId',
          name: 'detailcost',
          component: DetailCost,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/discount',
          name: 'discount',
          component: Discount,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/revenue',
          name: 'revenue',
          component: Revenue,
          meta: { isStaff: true }
        },
        {
          path: '/admin/unwatched-devices',
          name: 'unwatcheddevices',
          component: UnwatchedDevices,
          meta: { isStaff: true }
        },
        {
          path: '/admin/watched-devices',
          name: 'watcheddevices',
          component: WatchedDevices,
          meta: { isStaff: true }
        },
        {
          path: '/admin/pertamina',
          name: 'pertaminareport',
          component: PertaminaReport,
          meta: { isPertamina: true },
        },
        {
          path: '/admin/task',
          name: 'pulsetask',
          component: PulseTask,
          meta: { isStaff: true }
        },
        {
          path: '/admin/unassigned-ticket',
          name: 'unassignedticket',
          component: UnassignedTicket,
          meta: { isStaff: true }
        },
        {
          path: '/admin/task-performance/',
          name: 'taskperformance',
          component: TaskPerformance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/remote',
          name: 'remote',
          component: Remote,
          meta: { isStaff: true }
        },
        {
          path: '/admin/remote/terminal',
          name: 'terminal',
          component: Terminal,
          meta: { isStaff: true }
        },
        {
          path: '/admin/playbacksummary',
          name: 'playbacksummary',
          component: PlaybackSummary,
          meta: { isStaff: true }
        },
        {
          path: '/admin/channel/bus',
          name: 'buschannel',
          component: BusChannel,
          redirect: '/admin/channel/bus/route',
          meta: {isStaff: true},
          children: [
            {
              path: '/admin/channel/bus/route',
              name: 'busroute',
              component: BusRoute,
              meta: { isStaff: true }
            },
            {
              path: '/admin/channel/bus/placement',
              name: 'busplacement',
              component: BusPlacement,
              meta: { isStaff: true }
            },
          ]
        },
        {
          path: '/admin/channel/bus/route/add',
          name: 'addnewroute',
          component: AddEditRoute,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/bus/route/:id/edit',
          name: 'editroute',
          component: AddEditRoute,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/bus/placement/add',
          name: 'addnewbusplacement',
          component: AddEditPlacement,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/bus/placement/:id/edit',
          name: 'editbusplacement',
          component: AddEditPlacement,
          meta: { isStaff: true }
        },
        {
          path: '/admin/channel/airlines',
          name: 'airlinechannel',
          component: AirlineChannel,
          redirect: '/admin/channel/airlines/media',
          meta: {isAdminChannel: true},
          children: [
            {
              path: '/admin/channel/airlines/media',
              name: 'airlinemedia',
              component: AirlineMedia,
              meta: { isAdminChannel: true },
            },
            {
              path: '/admin/channel/airlines/placement',
              name: 'airlineplacement',
              component: AirlinePlacement,
              meta: { isAdminChannel: true }
            },
          ]
        },
        {
          path: '/admin/channel/airlines/media/addnew',
          name: 'addmediaairline',
          component: AirlineMediaForm,
          meta: { isAdminChannel: true }
        },
        {
          path: '/admin/channel/airlines/media/:id/edit',
          name: 'editmediaairline',
          component: AirlineMediaForm,
          meta: { isAdminChannel: true }
        },
        {
          path: '/admin/channel/airlines/placement/addnew',
          name: 'addplacementairline',
          component: AirlinePlacementForm,
          meta: { isAdminChannel: true }
        },
        {
          path: '/admin/channel/airlines/placement/:id/edit',
          name: 'editplacementairline',
          component: AirlinePlacementForm,
          meta: { isAdminChannel: true }
        }, 
        {
          path: '/admin/channel/profile/addnew',
          name: 'addnewprofileairline',
          component: AirlineProfile,
          meta: { isStaff: true }
        },
        {
          path: '/admin/channel/profile/:id/edit',
          name: 'editprofileairline',
          component: AirlineProfile,
          meta: { isStaff: true }
        },
        {
          path: '/admin/listings',
          name: 'listings',
          component: Listings,
          redirect: '/admin/listings/digitalscreen',
          meta: { isStaff: true },
          children: [
            {
              path: '/admin/listings/digitalscreen',
              name: 'digitalscreenlistings',
              component: DigitalScreenListings,
              meta: { isStaff: true }
            },
            {
              path: '/admin/listings/bus',
              name: 'buslistings',
              component: BusListings,
              meta: { isStaff: true }
            },
          ]
        },
        {
          path: '/admin/listings/addnew',
          name: 'addnewlisting',
          component: AddNewListing,
          meta: { isStaff: true }
        },
        // Task Manager
        {
          path: '/admin/taskmanager/assignment',
          name: 'taskassignment',
          component: TaskAssignment,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/assignement/new',
          name: 'newtask',
          component: NewTask,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/assesment',
          name: 'taskassesment',
          component: TaskAssesment,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/campaign',
          name: 'campaignmonitoring',
          component: CampaignMonitoring, 
          meta: { isOpsSpvOrGA: true }
        },
        {
          path: '/admin/taskmanager/campaign/new',
          name: 'campaignmonitoringnew',
          component: NewCampaignMonitoring,
          meta: { isOpsSpvOrGA: true }
        },
        {
          path: '/admin/taskmanager/campaign/:id',
          name: 'campaignmonitoringedit',
          component: EditCampaignMonitoring,
          meta: { isOpsSpvOrGA: true }
        },
        {
          path: '/admin/channel/billboard',
          name: 'billboardchannel',
          component: BillboardChannel,
          redirect: '/admin/channel/billboard/location',
          meta: { isStaff: true },
          children: [
            {
              path: '/admin/channel/billboard/location',
              name: 'billboardlocation',
              component: BillboardLocation,
              meta: { isStaff: true }
            },
            {
              path: '/admin/channel/billboard/placement',
              name: 'billboardplacement',
              component: BillboardPlacement,
              meta: { isStaff: true }
            },
          ]
        },
        {
          path: '/admin/channel/billboard/placement/add',
          name: 'addnewbillboardplacement',
          component: AddEditPlacementBillboard,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/billboard/placement/:id/edit',
          name: 'editbillboardplacement',
          component: AddEditPlacementBillboard,
          meta: { isStaff: true }
        },
        {
          path: '/admin/channel/billboard/location/add',
          name: 'addnewbillboardlocation',
          component: AddEditLocationBillboard,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/billboard/location/:id/edit',
          name: 'editbillboardlocation',
          component: AddEditLocationBillboard,
          meta: { isStaff: true }
        },
      ]
  },
]

export default adminRouter;
